import styled from 'styled-components';

import colors from 'styles/theme/colors';
import AISparkleIcon from 'svg/AISparkleIcon';

import Button, { ButtonProps } from '../Button';

const StyledButton = styled(Button)`
  display: flex;
  gap: 8px;
  background: ${colors.ai};
  background-color: ${colors.purpleHover};
  color: white;
  border: none;
  font-size: 12px;
  padding: 8px 16px;
  height: 36px;
`;

export default function AIButton({ children, ...props }: React.PropsWithChildren & ButtonProps) {
  return (
    <StyledButton {...props}>
      <AISparkleIcon color={colors.white} /> {children}
    </StyledButton>
  );
}
